/**
 * Dispatch.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {
  // tableName: 'viajes',

  attributes: {
    files: {
      type: "file"
    },

    createdBy: {
      model: "user",
      required: true
    },

    id: {
      type: "number",
      required: true,
      unique: true,
      columnName: "id"
    },

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    pickupCommitmentTime: {
      type: "ref",
      columnType: "datetime",
      required: true
      // columnName: 'fecha_recoleccion_compromiso'
    },

    deliveryCommitmentTime: {
      type: "ref",
      columnType: "datetime",
      required: true
      // columnName: 'fecha_entrega_compromiso'
    },

    incremental: {
      type: "ref",
      columnType: "datetime"
    },

    receivedAt: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_recibido'
    },

    approvedAt: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_aprobado'
    },

    startedAt: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_inicio'
    },

    finishedAt: {
      type: "ref",
      columnType: "datetime",
      required: true
      // columnName: 'fecha_finalizado'
    },

    closedAt: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_cerrado'
    },

    canceledAt: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_cancelacion'
    },

    canceledBy: {
      model: "user"
      // columnName: 'cancelado_por'
    },

    cancelComment: {
      type: "string",
      columnType: "text",
      allowNull: true
      // columnName: 'comentario_cancelado'
    },

    comments: {
      type: "string",
      columnType: "text",
      allowNull: true
      // columnName: 'comentarios'
    },

    urgent: {
      type: "boolean",
      defaultsTo: false
      // columnName: 'urgente'
    },

    exchangeRate: {
      type: "number",
      allowNull: true,
      required: true
      // columnName: 'tipo_cambio'
    },

    amount: {
      type: "number",
      required: true,
      currency: true
      // columnName: 'importe'
    },

    currency: {
      type: "string",
      required: true
      // columnName: 'moneda'
    },

    customerArrivalTime: {
      type: "ref",
      columnType: "datetime",
      required: true
      // columnName: 'fecha_llegada_origen'
    },

    shipperTime: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_shipper'
    },

    pedimentTime: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_pedimento'
    },

    customerDepartureTime: {
      type: "ref",
      columnType: "datetime",
      required: true
      // columnName: 'fecha_salida_origen'
    },

    customHouseMx: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_aduana_mx'
    },

    customHouseUs: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fecha_aduana_us'
    },

    statusMx: {
      model: "statusmx"
      // columnName: 'estatus_aduana_mx'
    },

    statusUs: {
      model: "statusus"
      // columnName: 'estatus_aduana_us'
    },

    customQueue: {
      type: "ref",
      columnType: "datetime"
      // columnName: 'fila_aduana'
    },

    deliveryTime: {
      type: "ref",
      columnType: "datetime",
      required: true
      // columnName: 'fecha_entrega'
    },

    signature: {
      type: "boolean",
      defaultsTo: false
      // columnName: 'firma'
    },

    customerTaxIdRegistrationNumber: {
      type: "string",
      columnType: "text",
      allowNull: true
    },

    customerTaxResidence: {
      type: "string",
      columnType: "text",
      allowNull: true
    },

    isLeasing: {
      type: "boolean"
    },

    isCollection: {
      type: "boolean"
    },

    supplierCost: {
      type: "number",
      currency: true,
      allowNull: true
    },

    supplierExtraChargesCost: {
      type: "number",
      currency: true,
      allowNull: true
    },
    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝

    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    internalOrder: {
      type: "number",
      allowNull: true
      // columnName: 'orden_interna_id'
    },

    isForwarder: {
      type: "boolean"
    },

    customer: {
      model: "customer",
      required: true
      // columnName: 'cliente_id'
    },

    origin: {
      model: "location",
      required: true
      // columnName: 'origen_id'
    },

    destination: {
      model: "location",
      required: true
      // columnName: 'destino_id'
    },

    supplier: {
      model: "supplier",
      required: true
      // columnName: 'proveedor_id'
    },

    economicNumber: {
      type: "string",
      required: true
      // columnName: 'numero_economico'
    },

    supplierNumber: {
      type: "string",
      allowNull: true
    },

    operativeReferenceNumber: {
      type: "string",
      allowNull: true
    },

    containerNumber: {
      type: "string",
      allowNull: true
    },

    boxNumber: {
      type: "string",
      allowNull: true
    },

    uuidReference: {
      type: "string",
      allowNull: true
    },

    type: {
      model: "dispatchtype",
      required: true
      // columnName: 'tipo_viaje_id'
    },

    serviceType: {
      model: "servicetype",
      required: true
      // columnName: 'tipo_servicio_id'
    },

    vehicle: {
      model: "vehicle"
      // required: true,
      // columnName: 'vehiculo_id'
    },

    vehicletype: {
      model: "vehicletype",
      required: true
      // columnName: 'vehiculo_id'
    },

    driver: {
      model: "driver",
      required: true
      // columnName: 'chofer_id'
    },

    billType: {
      model: "billtype",
      required: true
      // columnName: 'tipo_factura_id'
    },

    office: {
      model: "office",
      required: true
      // columnName: 'sede_id'
    },

    references: {
      collection: "reference",
      via: "dispatch"
    },

    checkpoints: {
      collection: "checkpoint",
      via: "dispatch"
    },

    charges: {
      collection: "charge",
      via: "dispatch"
    },

    transits: {
      collection: "transit",
      via: "dispatch"
    },

    items: {
      collection: "item",
      via: "dispatch"
    },

    stopOvers: {
      collection: "stopover",
      via: "dispatch"
    },

    customsRegime: {
      model: "customsRegime",
      required: true
    },

    collectionTransit: {
      model: "dispatch"
    },
    trailerPlates: {
      type: "string",
      required: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/Dispatch.js